import React from "react";

type Props = {
    json: any;
};

const AIAgentEvaluatePopup: React.FC<Props> = ({ json }) => {
    return (
        <div>
            <h5>AI Agent Evaluate Popup</h5>
            <div>
                <strong>JSON recibido:</strong>
                <pre style={{ whiteSpace: "pre-wrap" }}>
                    {JSON.stringify(json, null, 2)}
                </pre>
            </div>
        </div>
    );
};

export default AIAgentEvaluatePopup;